import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mappingCodeStr'
})
export class MappingCodeStrPipe implements PipeTransform {

  transform(value: any, args?: any): any {
     let str = value.code;
     if(value.dialstatus.length > 0){
         str = str + ' - ' + value.dialstatus;
     }

     str = str + ' - ' + value.status;
     if(value.campaign_name.length > 0){
         str = str + ' - (' +   value.campaign_name + ')'
     }
     return str;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/beeztel-codes/pipes/mapping-code-str.pipe.ts